import type { IAddressAdapter } from "@/domains/address/adapters/address-adapter.ts";
import type { TBackofficeNormalizedAddress } from "@/domains/address/dto/normalized-address.ts";
import type { TGeocodedAddressDto } from "@/types/backoffice/dto/site/site-dto.ts";

export const BackofficeNormalizedAddressToBackofficeAddress: IAddressAdapter<
  TBackofficeNormalizedAddress,
  TGeocodedAddressDto
> = {
  adapt(address: TBackofficeNormalizedAddress) {
    return address.raw;
  },
};
